import { Button } from '@fiado/react-kit';

export interface PoolPickerOption {
    tenantId: string;
    displayName: string;
}

interface PoolPickerProps {
    /** Texto que explica por qué hay que elegir (varía login vs forgot-password). */
    prompt: string;
    /** Candidatos resueltos por `resolveTenants` (multipool: 2+). */
    options: PoolPickerOption[];
    /** Se llama con el candidato elegido. */
    onPick: (option: PoolPickerOption) => void;
    /** Acción secundaria (ej. "Cambiar correo" / "Volver"). */
    secondaryLabel: string;
    onSecondary: () => void;
}

/**
 * Picker de pool/tenant para flujos multipool (un email puede existir en varios pools).
 * Se reusa en el login (paso PICK) y en forgot-password (paso PICK): cuando
 * `resolveTenants` devuelve 2+ candidatos, el usuario elige de cuál cuenta operar y el
 * `tenantId` elegido se propaga al backend para que resuelva el pool correcto.
 *
 * Mismo estilo visual que el picker original del login: un `Button variant="outline"`
 * full-width por candidato, mostrando `displayName`.
 */
export function PoolPicker({
    prompt,
    options,
    onPick,
    secondaryLabel,
    onSecondary,
}: PoolPickerProps) {
    return (
        <div className="space-y-3">
            <p className="text-sm">{prompt}</p>
            {options.map((opt) => (
                <Button
                    key={opt.tenantId}
                    type="button"
                    variant="outline"
                    fullWidth
                    className="justify-start hover:bg-muted hover:text-foreground"
                    onClick={() => {
                        onPick(opt);
                    }}
                >
                    {opt.displayName}
                </Button>
            ))}
            <Button
                type="button"
                variant="ghost"
                fullWidth
                className="text-sm hover:bg-muted hover:text-foreground"
                onClick={onSecondary}
            >
                {secondaryLabel}
            </Button>
        </div>
    );
}
